import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import { getFirebaseBackend } from 'helpers/firebaseHelper';

const DEFAULT_LOGO = '/default-account-logo.png';

const AccountLogo = ({ accountId }) => {
  const firebaseHelper = getFirebaseBackend();

  const accountQuery = useQuery({
    queryKey: ['account', accountId],
    queryFn: () => firebaseHelper.getAccount(accountId),
    enabled: Boolean(accountId),
    cacheTime: 1000 * 5,
    staleTime: 1000 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const logoUrl = accountQuery.data?.logoUrl || DEFAULT_LOGO;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <img className="task-summary-logo" src={logoUrl} alt="" style={{ display: 'block' }} />
      <i
        className="bx bx-loader-alt task-summary-loading-icon"
        style={{
          display: accountQuery.isLoading ? 'inline' : 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  );
};

AccountLogo.propTypes = {
  accountId: PropTypes.string,
};

export default AccountLogo;
